"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgDepartmentSelector = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const input_select_1 = require("../../components/input/input.select");
const mithril_component_1 = require("../../components/mithril.component");
const spinner_1 = require("../../components/spinner/spinner");
const i18n_1 = require("../../i18n");
const org_department_selector_ctrl_1 = require("./org.department.selector.ctrl");
class OrgDepartmentSelector extends mithril_component_1.IMithrilStateComponent {
    constructor(selectorOptions = { crossOrganization: false }) {
        super();
        this.ctrl = new org_department_selector_ctrl_1.OrgDepartmentSelectorCtrl(selectorOptions.crossOrganization);
        this.inputState = new input_select_1.SelectInputState(i18n_1.T.DEPARTMENT);
        this.inputState.isRequired = true;
        this.reaction(() => this.ctrl.departmentOptions, options => {
            this.inputState.setOptions(options);
            if (options.length > 0 && this.inputState.value == null) {
                this.inputState.setValue(options[0].value);
            }
        }, { fireImmediately: true });
        this.reaction(() => this.inputState.value, departmentId => this.ctrl.selectDepartment(departmentId), { fireImmediately: true });
    }
    get nodes() {
        if (this.inputState == null) {
            return null;
        }
        if (this.ctrl.loadingDepartments) {
            return spinner_1.Spinner.view();
        }
        return input_select_1.SelectInputComponent.view(this.inputState);
    }
    get selectedDepartmentId() {
        return this.ctrl.selectedDepartmentId;
    }
}
exports.OrgDepartmentSelector = OrgDepartmentSelector;
tslib_1.__decorate([
    mobx_1.computed
], OrgDepartmentSelector.prototype, "selectedDepartmentId", null);
//# sourceMappingURL=org.department.selector.js.map